import { QueryHookOptions, useQuery } from '@apollo/client';

import { TEACHER_BY_ID, PARENT_BY_ID } from './queries';

import { User } from './types';

export const useTeacherById = (id: number | null, options?: QueryHookOptions) => useQuery<{ user: User }>(TEACHER_BY_ID, { ...options, variables: { id } });

export const useParentById = (id: number | null, options?: QueryHookOptions) => useQuery<{ user: User }>(PARENT_BY_ID, { ...options, variables: { id } });
